import React from 'react'
import Page from '../components/Page'
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react'
import { Capacitor } from '@capacitor/core'
import { lockOpenOutline } from 'ionicons/icons'

export default class extends React.Component {
    render() {
        return (
            <Page title="Internes" large>
                <IonList>
                    <IonItem routerLink="/uebersichtstabellen/richtpreise">
                        <IonLabel className="ion-text-wrap" >
                        <h2>Richtpreise Entsorgung</h2>
                        <p>Erfahrungswerte für Entsorgungspreise für mineralische Bauabfälle </p>
                        </IonLabel>
                    </IonItem>                    
                </IonList>
            </Page>
        )
    }
}